import { render } from "./index.vue?vue&type=template&id=228a2ec7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=228a2ec7&lang=less&scoped=true"

import exportComponent from "C:\\work\\takeda\\ui\\takeda_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228a2ec7"],['__file',"src/layout/module/header/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "228a2ec7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('228a2ec7', __exports__)) {
    console.log('reload')
    api.reload('228a2ec7', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=228a2ec7&scoped=true", () => {
    console.log('re-render')
    api.rerender('228a2ec7', render)
  })

}


export default __exports__